import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoanComponent } from './loan.component';

export enum RouteName {
  default = '/loan',
  branch = '/loan/branch',
  applicant = '/loan/applicant',
  applicantHomeVehicles = '/loan/applicant/rent-vehicles',
  applicantEmployer = '/loan/applicant/employer',
  /**
   * URL used with applicant ONLY form type.
   */
  applicantOnlyBank = '/loan/applicant/bank',
  coApplicant = '/loan/co-applicant',
  coApplicantHomeVehicles = '/loan/co-applicant/rent-vehicles',
  coApplicantEmployer = '/loan/co-applicant/employer',
  /**
   * URL used with co-applicant form type.
   */
  bank = '/loan/bank',
  confirmation = '/loan/confirmation',
  skippedConfirmation = '/loan/skipped/confirmation',
}

const routes: Routes = [
  {
    path: '',
    component: LoanComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../loan/area/area.module').then((m) => m.AreaModule),
      },
      {
        path: 'branch',
        loadChildren: () =>
          import('../loan/branch/branch.module').then((m) => m.BranchModule),
      },
      {
        path: 'applicant',
        loadChildren: () =>
          import('../loan/applicant/applicant.module').then(
            (m) => m.ApplicantModule
          ),
      },
      {
        path: 'applicant/rent-vehicles',
        loadChildren: () =>
          import(
            '../loan/applicant-rent-vehicle/applicant-rent-vehicle.module'
          ).then((m) => m.ApplicantRentVehicleModule),
      },
      {
        path: 'applicant/employer',
        loadChildren: () =>
          import('../loan/applicant-employer/applicant-employer.module').then(
            (m) => m.ApplicantEmployerModule
          ),
      },
      {
        path: 'applicant/bank',
        loadChildren: () =>
          import('../loan/bank/bank.module').then((m) => m.BankModule),
      },
      {
        path: 'co-applicant',
        loadChildren: () =>
          import('../loan/co-applicant/co-applicant.module').then(
            (m) => m.CoApplicantModule
          ),
      },
      {
        path: 'co-applicant/rent-vehicles',
        loadChildren: () =>
          import(
            '../loan/co-applicant-rent-vehicle/co-applicant-rent-vehicle.module'
          ).then((m) => m.CoApplicantRentVehicleModule),
      },
      {
        path: 'co-applicant/employer',
        loadChildren: () =>
          import(
            '../loan/co-applicant-employer/co-applicant-employer.module'
          ).then((m) => m.CoApplicantEmployerModule),
      },
      {
        path: 'bank',
        loadChildren: () =>
          import('../loan/bank/bank.module').then((m) => m.BankModule),
      },
      {
        path: 'confirmation',
        loadChildren: () =>
          import('../loan/confirmation/confirmation.module').then(
            (m) => m.ConfirmationModule
          ),
      },
      {
        path: 'skipped/confirmation',
        loadChildren: () =>
          import(
            '../loan/skipped-confirmation/skipped-confirmation.module'
          ).then((m) => m.SkippedConfirmationModule),
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoanRoutingModule {}
